// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./plugins/jobs/web_client/stylesheets/jobDetailsWidget.styl
// module id = 950
// module chunks = 0